import { useCallback, useEffect, useState } from "react";
import DebitCard from "../../../components/pending-approvals/debitCard";
import PendingAuthService from "../../../services/approvals.service";
import { useNavigate } from "react-router";
import { Breadcrumb, Card, Empty, Tabs, Button } from "antd";
import SelectAllCard from "../../../components/pending-approvals/selectAll";
import download from "../../../assests/icons/download_icon.png";
import { AiOutlineLeft } from "react-icons/ai";
import { ReactComponent as TitleIcon } from "../../../assests/images/transfer.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";

export default function HistoryDebitCard() {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const { t } = useTranslation();
  useEffect(() => {
    getPendingRecords();
  }, []);

  const getPendingRecords = useCallback(async () => {
    try {
      const response = await PendingAuthService.debitCardGetRecords({
        listType: "A",
      });
      if (response.status === 200) {
        setDataSource(response.data["data"]);
      }
    } catch (error) {}
  }, []);

  const handleDownload = useCallback(async () => {
    try {
      const reqParams = {
        listType: "A",
      };
      await PendingAuthService.debitCardRecDownload(reqParams);
    } catch (err) {}
  }, []);

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/history")}>
              {t("navigation.history", {
                defaultValue: "History",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.profile.debit_card", {
                defaultValue: "Debit Card",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.profile.debit_card", {
                defaultValue: "Debit Card",
              })}
            </h3>
          </div>
          <div className=" col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end">
            {dataSource.length === 0 ? null : (
              <Button
                type="default"
                className="btn-primary"
                onClick={handleDownload}
              >
                <img
                  alt="download"
                  src={download}
                  height={20}
                  style={{ paddingRight: "15px" }}
                />
                {t("buttons.download_btn", { defaultValue: "Download" })}
              </Button>
            )}
          </div>
        </div>
      </Card>

      <Card className="application-card">
        <div className="row px-2">
          {dataSource.length === 0 ? (
            <Empty
              description={t("common.no_records_found", {
                defaultValue: "No Records Found",
              })}
            />
          ) : (
            <div className="ft-table">
              <table className="table " style={{ cursor: "pointer" }}>
                <thead style={{ backgroundColor: "#F1F1F1" }}>
                  <tr>
                    <th>
                      {t("pages.gepeg.source_account", {
                        defaultValue: "Source Account",
                      })}
                    </th>
                    <th>
                      {t("pages.pay_bills.biller_name", {
                        defaultValue: "Biller Name",
                      })}
                    </th>
                    <th
                      title={t("pages.pending_approval.consumer_number", {
                        defaultValue: "Consumer Number",
                      })}
                    >
                      {" "}
                      {t("pages.pending_approval.consumer_number", {
                        defaultValue: "Consumer Number",
                      })}
                    </th>
                    <th>
                      {t("pages.view_scheduled_transfer.payment_type", {
                        defaultValue: "Payment Type",
                      })}
                    </th>
                    <th>{t("common.amount", { defaultValue: "Amount" })}</th>
                    <th>
                      {t("pages.pending_approval.Initiated_Date", {
                        defaultValue: "Initiated Date",
                      })}
                    </th>
                    <th title={t("pages.pending_approval.transaction_status", {
                        defaultValue: "Transaction status",
                      })}>
                      {t("pages.pending_approval.transaction_status", {
                        defaultValue: "Transaction status",
                      })}
                    </th>
                    <th>{t("common.status", { defaultValue: "Status" })}</th>
                  </tr>
                </thead>
                <tbody>
                  {dataSource.map((option, index) => (
                    <DebitCard record={option} />
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </Card>
    </>
  );
}
